import { render, staticRenderFns } from "./membersPartner.pug?vue&type=template&id=0633fb9a&scoped=true&lang=pug&"
import script from "./membersPartner.ts?vue&type=script&lang=ts&"
export * from "./membersPartner.ts?vue&type=script&lang=ts&"
import style0 from "./membersPartner.scss?vue&type=style&index=0&id=0633fb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633fb9a",
  null
  
)

export default component.exports